import React, { ReactNode, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import {
    PUBLIC_APP_INSIGHTS_KEY_ENV,
    PUBLIC_GTM_ID_ENV,
    PUBLIC_CHANNEL,
} from 'tools/environments';
import { PageTemplate } from '../patterns';
import { GetSimpleFooterResponse } from 'services/idm';
import styles from './layout.module.scss';

type LayoutProps = {
    children: ReactNode;
    footerData: GetSimpleFooterResponse;
    backgroundUrl?: string;
    playerUrl?: string;
};

const analyticsConfig = {
    gtmId: PUBLIC_GTM_ID_ENV,
    applicationInsightsConnectionString: PUBLIC_APP_INSIGHTS_KEY_ENV,
};

export const Layout = ({
    children,
    footerData,
    backgroundUrl = '',
    playerUrl = '',
}: LayoutProps) => {
    const [backgroundImage, setBackgroundImage] = useState('');
    const [playerImage, setPlayerImage] = useState('');
    const { query } = useRouter();
    const isFromApp = query.fromapp !== undefined ? true : false;
    const theme = PUBLIC_CHANNEL || 'mancity';

    const handleImages = () => {
        if (backgroundUrl) {
            setBackgroundImage(backgroundUrl);
        } else setBackgroundImage(`/images/${theme}/signin-background.webp`);
        if (playerUrl) {
            setPlayerImage(playerUrl);
        } else
            setPlayerImage(
                `/images/${theme}/players/player${
                    Math.floor(Math.random() * 4) + 1
                }.webp`
            );
    };

    const handlePlayerImageError = (
        e: React.SyntheticEvent<HTMLImageElement>
    ) => {
        const imgElement = e.currentTarget as HTMLImageElement;
        imgElement.onerror = null;
        imgElement.src = `/images/${theme}/player.webp`;
    };

    useEffect(() => {
        handleImages();
    }, []);

    return (
        <>
            <PageTemplate footerData={footerData} config={analyticsConfig}>
                <div className={styles.backgroundWrapper}>
                    <div className={styles.imageContainer}>
                        {backgroundImage && (
                            <>
                                <Image
                                    src={backgroundImage}
                                    alt="background"
                                    className={styles.background}
                                    fill
                                    style={{ objectFit: 'cover' }}
                                    priority
                                />
                                <img
                                    src={playerImage}
                                    alt="player"
                                    className={styles.player}
                                    onError={handlePlayerImageError}
                                />
                            </>
                        )}
                    </div>
                    <div className="container">
                        <div className={`row`}>
                            <div className="col-12">
                                <div className={`${styles.container}`}>
                                    <div className={styles.formWrapper}>
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageTemplate>
        </>
    );
};
